import { Subject } from "rxjs";

export const refreshMonitorData = new Subject();
export const loadMoreContact = new Subject();
export const refreshRecentChat = new Subject();
